










































































































import {
	defineComponent,
	computed,
	watch,
	ref,
	Ref,
} from '@vue/composition-api';
import type { Model as SurveyJsModel } from 'survey-vue';
import { Size } from '@front-app/components/constants';
import { Routes } from '@front-app/constants/routes';
import { getSurveysStore } from '@front-app/modules/surveys/store/SurveysStore';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PlusButton from '@front-app/components/buttons/PlusButton.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import IconDropdown from '@front-app/components/dropdowns/IconDropdown.vue';
import EditButton from '@front-app/components/buttons/concrete/EditButton.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';

export default defineComponent({
	components: {
		PlusButton,
		SimpleCard,
		LoaderState,
		ErrorCard,
		ColumnHeader,
		IconDropdown,
		FontAwesomeIcon,
		EditButton,
		CtaButton,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const {
			hasAllLearningProgramsManagementAccess,
		} = useAdminAccess(group);
		const toSurveyCreatePage = computed(() => ({
			name: Routes.GROUP_ADMIN_SURVEY_CREATE,
		}));
		const toSurveyEditPage = (surveyId: string) => ({
			name: Routes.GROUP_ADMIN_SURVEY_EDIT,
			params: {
				surveyId,
			},
		});
		const toSurveyResponsesPage = (surveyId: string) => ({
			name: Routes.GROUP_ADMIN_SURVEY_RESPONSES,
			params: {
				surveyId,
			},
		});

		const surveyStore = getSurveysStore();
		const {
			track,
			isError: isListFetchError,
			isLoading: isListFetchLoading,
		} = useAsyncStatus();
		watch(() => props.groupId, () => {
			track(surveyStore.fetchSurveysForGroup(props.groupId));
		}, { immediate: true });
		const surveys = computed(() => surveyStore.getGroupSurveys(props.groupId));
		const getSurveyName = (surveyContent: string) => {
			const data = (JSON.parse(surveyContent) as SurveyJsModel);
			return data.title;
		};

		const surveyIdWithOpenActionsMenu: Ref<string | null> = ref(null);
		const isActionsDropdownOpen = (id: string) => id === surveyIdWithOpenActionsMenu.value;
		const closeActionsDropdown = (id: string) => {
			if (isActionsDropdownOpen(id)) {
				surveyIdWithOpenActionsMenu.value = null;
			}
		};
		const toggleActionsDropdown = (id: string) => {
			if (isActionsDropdownOpen(id)) {
				closeActionsDropdown(id);
			} else {
				surveyIdWithOpenActionsMenu.value = id;
			}
		};

		return {
			hasAllLearningProgramsManagementAccess,
			toSurveyCreatePage,
			toSurveyEditPage,
			toSurveyResponsesPage,
			// Status
			isListFetchError,
			isListFetchLoading,
			// Data
			surveys,
			getSurveyName,
			// Actions
			isActionsDropdownOpen,
			closeActionsDropdown,
			toggleActionsDropdown,
			// Util
			Size,
		};
	},
});
